import {Api} from 'api';
import {callApi} from 'root/appSaga';
import {all, put, takeEvery} from 'redux-saga/effects';
import * as telematicAccountsActions from 'features/telematics/telematicAccountsActions';
import {TelematicProviderTypeMetadata} from "../../types";


export function* companyTelematicAccountsSaga() {
    // @ts-ignore
    return yield all([
        takeEvery(telematicAccountsActions.REQUEST_COMPANY_TELEMATIC_ACCOUNTS_START, getCompanyTelematicAccounts)
    ]);
}

export function* getCompanyTelematicAccounts() {
    try {
        const accounts: TelematicProviderTypeMetadata[] = yield callApi(Api.getCompanyTelematicAccounts);
        yield put(telematicAccountsActions.getCompanyTelematicAccountsCompleted(accounts));
    } catch (error) {
        yield put(telematicAccountsActions.getCompanyTelematicAccountsError(error));
    }
}
